import { connect } from "react-redux";
import { sessionSlice } from "../../store/sessionSlice";
import { sceneSlice } from "../../store/sceneSlice";
import XrScienceMenu from "../components/XrScienceMenu";

const mapStateToProps = (state) => {
  return {
    availableRooms: state.session.availableRooms,
    isConnected: state.session.isConnected,
    isConnectedToASession: state.session.sessionStatus === "ACTIVE" || state.session.sessionStatus === "MINIMIZING",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRequestNewRoom: (data) => {
      dispatch(sessionSlice.actions.emitRequestNewRoom(data));
    },
  };
};

export const XrScienceMenuContainer = connect(mapStateToProps, mapDispatchToProps)(XrScienceMenu);
